import React, { useState, useRef } from "react";
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";

type BeforeAfterProps = {
  beforeImage: string | undefined;
  afterImage: string | undefined;
};

const BeforeAfterSlider: React.FC<BeforeAfterProps> = ({
  beforeImage,
  afterImage,
}) => {
  const [position, setPosition] = useState(47);
  const containerRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);

  const handleMove = (clientX: number) => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      let newPosition = ((clientX - rect.left) / rect.width) * 100;
      newPosition = Math.max(0, Math.min(100, newPosition));
      setPosition(newPosition);
    }
  };

  const handleMouseMove = (event: MouseEvent) => {
    if (isDragging.current) {
      handleMove(event.clientX);
    }
  };

  const handleTouchMove = (event: TouchEvent) => {
    if (isDragging.current && event.touches.length > 0) {
      handleMove(event.touches[0].clientX);
    }
  };

  const handleDown = () => {
    isDragging.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleUp);
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchend", handleUp);
  };

  const handleUp = () => {
    isDragging.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleUp);
    document.removeEventListener("touchmove", handleTouchMove);
    document.removeEventListener("touchend", handleUp);
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        margin: "auto",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          src={beforeImage}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            clipPath: `inset(0 ${100 - position}% 0 0)`,
          }}
          alt="Before"
        />
        <img
          src={afterImage}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            clipPath: `inset(0 0 0 ${position}%)`,
          }}
          alt="After"
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            width: "2px",
            backgroundColor: "#12B6EA",
            left: `${position}%`,
          }}
        ></Box>
        <IconButton
          onMouseDown={handleDown}
          onTouchStart={handleDown}
          sx={{
            width:"50px",
            height: "50px",
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: `${position}%`,
             background: "linear-gradient(222deg, #12B6EA 0%, #0A6784 100%)", // <-- Added gradient
            color: "white",
            boxShadow: 3,
           
          }}
        >

          <ArrowBackIosNewOutlined sx={{ fontSize:"16px" }}/>
          <ArrowBackIosNewOutlined sx={{ fontSize:"16px", transform:"rotate(180deg)"}}/>

        </IconButton>
      </Box>
    </Box>
  );
};

export default BeforeAfterSlider;
